
document.addEventListener("DOMContentLoaded", function() {
  var faqData = [];
  document.querySelectorAll('.collapsible-row-list').forEach(function(section) {
    section.querySelectorAll('.collapsible-row-list-item').forEach(function(item) {
      var questionElement = item.querySelector('.collapsible-row-list-item__heading');
      var answerElement = item.querySelector('.collapsible-row-list-item__text');
      if (questionElement && answerElement) {
        faqData.push({
          "@type": "Question",
          "name": questionElement.innerText,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": answerElement.innerText
          }
        });
      }
    });
  });
  if (faqData.length === 0) return;
  var faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData
  };
  var script = document.createElement('script');
  script.type = "application/ld+json";
  script.textContent = JSON.stringify(faqSchema);
  document.head.appendChild(script);
});

